import React, { useContext } from 'react';
import { useStyletron } from 'baseui';
import { Redirect, useHistory } from 'react-router-dom';
import { Button } from 'baseui/button';

import { UserContext } from 'commons-ui';

type IPrivateRouteProps = {
	errorMsg: string;
	statusCode: number;
};

const CustomError: React.FC<IPrivateRouteProps> = ({ errorMsg, statusCode }) => {
	const [css] = useStyletron();
	const history = useHistory();
	const { logoutUser } = useContext(UserContext);

	const goToHome = () => {
		history.replace('/');
	};

	if (statusCode === 401 || statusCode === 402) {
		logoutUser();
		return (
			<Redirect
				to={{
					pathname: '/login'
				}}
			/>
		);
	}

	return (
		<div
			className={css({
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100%'
			})}>
			<span
				className={css({
					marginBottom: '2%'
				})}>
				{statusCode} - {errorMsg}
			</span>
			<Button onClick={goToHome}>Go to Home</Button>
		</div>
	);
};

export default CustomError;
